import { c as _c } from "react/compiler-runtime";
import type { RuleExpressionCondition } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
type RuleChipProps = {
  ruleExpression: RuleExpressionCondition;
};
const RuleChip = t0 => {
  const $ = _c(18);
  const {
    ruleExpression
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings.rules.ruleRow"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] !== ruleExpression.op || $[2] !== t) {
    t2 = () => {
      if (ruleExpression.op === "eq") {
        return t(_temp);
      }
      if (ruleExpression.op === "not_eq") {
        return t(_temp2);
      }
    };
    $[1] = ruleExpression.op;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const getOperator = t2;
  let t3;
  if ($[4] !== ruleExpression.field) {
    t3 = <span className="text-caption-1 min-w-0 wrap-anywhere">{ruleExpression.field}</span>;
    $[4] = ruleExpression.field;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== getOperator) {
    t4 = getOperator();
    $[6] = getOperator;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <span className="text-caption-1 min-w-fit">{t4}</span>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t(_temp3);
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <span className="text-caption-1 text-tertiary min-w-fit">{t6}</span>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t3 || $[15] !== t5 || $[16] !== t7) {
    t8 = <div className="h-fit min-w-0 max-w-full flex flex-wrap items-center gap-x-2 py-0.5 px-3 bg-primary rounded-full border border-solid border-tertiary overflow-hidden">{t3}{t5}{t7}</div>;
    $[14] = t3;
    $[15] = t5;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};
export default RuleChip;
function _temp($) {
  return $.op.eq;
}
function _temp2($_0) {
  return $_0.op.notEq;
}
function _temp3($_1) {
  return $_1.value.riskSignalValue;
}